import { render, staticRenderFns } from "./FormLocationItem.vue?vue&type=template&id=21a41935&scoped=true&"
import script from "./FormLocationItem.vue?vue&type=script&lang=js&"
export * from "./FormLocationItem.vue?vue&type=script&lang=js&"
import style0 from "./FormLocationItem.vue?vue&type=style&index=0&id=21a41935&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a41935",
  null
  
)

export default component.exports